import React from 'react'
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useGetLanguages } from 'helpers/commonCodes';
import Label, { useLabels } from 'components/general/Label';

export default function PersonBioData({ data }) {
  const { mirs_language, } = useUrlFriendlyToParameters()
  const isTeam = (data?.team)
  const dataLanguage = useGetLanguages()
  const bioData = (isTeam) ? data?.team?.teamBio : data?.person?.participantBio
  const fLabel = useLabels()

  let language = dataLanguage?.languages?.find(item => item.lang === mirs_language?.toUpperCase())?.description;
  if (language !== "EN" && language !== 'English') {
    return (<><br /><b>{fLabel({ data: 'LabelExtendedProfile' })}</b></>);
  }
  return (
    <>
      {bioData &&
        <>

          {(language !== 'EN' && language !== 'English') ?
            <>
              <div id="bio"><h2 className="wrsBiosDetail__h2"><Label data="HeaderBiographicalInformation" /></h2></div>
              <b><Label data="LabelExtendedProfile" /></b>
            </>
            :
            <>
              <section id="BiographicalInformation">
                <div id="bio"><h2 className="wrsBiosDetail__h2"><Label data="HeaderBiographicalInformation" /></h2></div>
                <div className="mb-2">
                  {bioData?.highlights && <div className="wrsNoc pt-2"><b><Label data="HeaderHighlights" />:</b></div>}

                  {bioData?.highlights?.map((hl, i) => (
                    <div key={i} className="" dangerouslySetInnerHTML={{ __html: hl.value }}></div>
                  ))}

                  {bioData?.highlights?.value && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.highlights?.value }}></div>}

                  {bioData?.interest?.award && <div className=" pt-2"><b><Label data="labelbioAWARD" />:</b></div>}
                  {bioData?.interest?.award && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.award }}></div>}

                  {bioData?.interest?.appointment && <div className=" pt-2"><b><Label data="labelbioAPPOINTMENT" />:</b></div>}
                  {bioData?.interest?.appointment && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.appointment }}></div>}

                  {bioData?.interest?.intAppointment && <div className=" pt-2"><b><Label data="labelbio_IntAPPOINTMENT" />:</b></div>}
                  {bioData?.interest?.intAppointment && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.intAppointment }}></div>}

                  {bioData?.interest?.otherRole && <div className=" pt-2"><b><Label data="labelbioOTHER_ROLE" />:</b></div>}
                  {bioData?.interest?.otherRole && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.otherRole }}></div>}

                  {bioData?.interest?.prevRole && <div className=" pt-2"><b><Label data="labelbioPREV_ROLE" />:</b></div>}
                  {bioData?.interest?.prevRole && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.prevRole }}></div>}

                  {bioData?.interest?.winLoss && <div className=" pt-2"><b><Label data="labelbioWIN_LOSS" />:</b></div>}
                  {bioData?.interest?.winLoss && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.winLoss }}></div>}

                  {bioData?.interest?.hobbies && <div className=" pt-2"><b><Label data="labelbioHOBBIES" />:</b></div>}
                  {bioData?.interest?.hobbies && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.hobbies }}></div>}

                  {bioData?.interest?.marStatus && <div className=" pt-2"><b><Label data="labelbioMAR_STATUS" />:</b></div>}
                  {bioData?.interest?.marStatus && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.marStatus }}></div>}

                  {bioData?.interest?.family && <div className=" pt-2"><b><Label data="LabelBio_Family" />:</b></div>}
                  {bioData?.interest?.family && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.family }}></div>}

                  {bioData?.interest?.positionStyle && <div className=" pt-2"><b><Label data="LabelBio_PositionStyle" />:</b></div>}
                  {bioData?.interest?.positionStyle && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.positionStyle }}></div>}

                  {bioData?.interest?.sportingRelatives && <div className=" pt-2"><b><Label data="labelbioSPORTING_RELATIVES" />:</b></div>}
                  {bioData?.interest?.sportingRelatives && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.sportingRelatives }}></div>}

                  {bioData?.interest?.otherSports && <div className=" pt-2"><b><Label data="LabelBio_OtherSports" />:</b></div>}
                  {bioData?.interest?.otherSports && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.otherSports }}></div>}

                  {bioData?.interest?.debut && <div className=" pt-2"><b><Label data="LabelBio_Debut" />:</b></div>}
                  {bioData?.interest?.debut && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.debut }}></div>}

                  {bioData?.interest?.music && <div className=" pt-2"><b><Label data="labelbioMUSIC" />:</b></div>}
                  {bioData?.interest?.music && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.music }}></div>}

                  {bioData?.interest?.choreographer && <div className=" pt-2"><b><Label data="labelbioCOREOGRAPHER" />:</b></div>}
                  {bioData?.interest?.choreographer && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.choreographer }}></div>}

                  {bioData?.interest?.natTeam && <div className=" pt-2"><b><Label data="labelbioNAT_TEAM" />:</b></div>}
                  {bioData?.interest?.natTeam && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.natTeam }}></div>}

                  {bioData?.interest?.natLeague && <div className=" pt-2"><b><Label data="labelbioNAT_LEAGUE" />:</b></div>}
                  {bioData?.interest?.natLeague && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.natLeague }}></div>}

                  {bioData?.interest?.ambition && <div className=" pt-2"><b><Label data="labelbioAMBITION" />:</b></div>}
                  {bioData?.interest?.ambition && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.ambition }}></div>}

                  {bioData?.interest?.memorable && <div className=" pt-2"><b><Label data="labelbioMEMORABLE" />:</b></div>}
                  {bioData?.interest?.memorable && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.memorable }}></div>}

                  {bioData?.interest?.ritual && <div className=" pt-2"><b><Label data="labelbioRITUAL" />:</b></div>}
                  {bioData?.interest?.ritual && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.ritual }}></div>}

                  {bioData?.interest?.education && <div className=" pt-2"><b><Label data="LabelBio_Education" />:</b></div>}
                  {bioData?.interest?.education && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.education }}></div>}

                  {bioData?.interest?.nickname && <div className=" pt-2"><b><Label data="LabelNickname" />:</b></div>}
                  {bioData?.interest?.nickname && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.nickname }}></div>}

                  {bioData?.interest?.prevNames && <div className=" pt-2"><b><Label data="labelbioPREVNAMES" />:</b></div>}
                  {bioData?.interest?.prevNames && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.prevNames }}></div>}

                  {bioData?.interest?.occupation && <div className=" pt-2"><b><Label data="LabelOccupation" />:</b></div>}
                  {bioData?.interest?.occupation && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.occupation }}></div>}

                  {bioData?.interest?.langSpoken && <div className=" pt-2"><b><Label data="LabelBio_LanguagesSpoken" />:</b></div>}
                  {bioData?.interest?.langSpoken && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.langSpoken }}></div>}

                  {bioData?.interest?.clubName && <div className=" pt-2"><b><Label data="labelbioCLUB_NAME" />:</b></div>}
                  {bioData?.interest?.clubName && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.clubName }}></div>}

                  {bioData?.interest?.coach && <div className=" pt-2"><b><Label data="labelbioCOACH" />:</b></div>}
                  {bioData?.interest?.coach && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.coach }}></div>}

                  {bioData?.interest?.hand && <div className=" pt-2"><b><Label data="labelbioHAND" />:</b></div>}
                  {bioData?.interest?.hand && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.hand }}></div>}

                  {bioData?.interest?.injuries && <div className=" pt-2"><b><Label data="labelbioINJURIES" />:</b></div>}
                  {bioData?.interest?.injuries && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.injuries }}></div>}

                  {bioData?.interest?.start && <div className=" pt-2"><b><Label data="labelbioSTART" />:</b></div>}
                  {bioData?.interest?.start && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.start }}></div>}

                  {bioData?.interest?.reason && <div className=" pt-2"><b><Label data="labelbioREASON" />:</b></div>}
                  {bioData?.interest?.reason && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.reason }}></div>}

                  {bioData?.interest?.training && <div className=" pt-2"><b><Label data="labelbioTRAINING" />:</b></div>}
                  {bioData?.interest?.training && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.training }}></div>}

                  {bioData?.interest?.hero && <div className=" pt-2"><b><Label data="labelbioHERO" />:</b></div>}
                  {bioData?.interest?.hero && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.hero }}></div>}

                  {bioData?.interest?.influence && <div className=" pt-2"><b><Label data="labelbioINFLUENCE" />:</b></div>}
                  {bioData?.interest?.influence && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.influence }}></div>}

                  {bioData?.interest?.philosophy && <div className=" pt-2"><b><Label data="labelbioPHILOSOPHY" />:</b></div>}
                  {bioData?.interest?.philosophy && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.philosophy }}></div>}
                </div>
              </section>
              <section id="GeneralInterest">
                <div className="mb-2">
                  <div id="addInformation"><h2 className="wrsBiosDetail__h2"><Label data="HeaderGeneralInterest" /></h2></div>
                  {bioData?.interest?.addInformation && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.addInformation }}></div>}
                </div>
              </section>
              <section id="milestones">
                <div className="mb-2">
                  <div id="milestones"><h2 className="wrsBiosDetail__h2"><Label data="HeaderMilestones" /></h2></div>
                  {bioData?.interest?.milestones && <div className="" dangerouslySetInnerHTML={{ __html: bioData?.interest?.milestones }}></div>}
                </div>
              </section>
              <section id='socialMedia'>
                <div id='socialMedia'>
                  {bioData?.interest?.extendedBios && <div className=" pt-2"><h3 id='socialMedaiHeading' className='wrsBiosDetail__socialMedia'><Label data="labelbioEXT_BIO_VALUE" />:</h3></div>}
                  {bioData?.interest?.extendedBios &&
                    <ul aria-labelledby='socialMedaiHeading'>
                      {bioData?.interest?.extendedBios.map((item, key) => <li className=" pt-1" key={item.code}>{item.code}: <a href={item.value} rel="noreferrer" target="_blank">{item.value}</a></li>)}     </ul>
                  }
                </div>
              </section>
            </>
          }
        </>
      }
    </>
  )
}